<template lang="">
  <div id="home_page">
    <div class="home_banner">
      <div class="h_left">
        <swiper ref="mySwiper" :options="bannerSwiper" class="h_left_swiper">
          <swiper-slide v-for="(item,index) in bannerList" :key="item.id" class="h_swiper_item">
            <router-link to="/"><img :src="item.picture" alt=""></router-link>
          </swiper-slide>
        </swiper>
        <div v-if="bannerList.length>0" class="hd">
          <ul class="dot">
            <li v-for="(item,index) in bannerList" :key="item.id" :class="{ on: currentIndex === index }"
              @mouseover="hoverSlide(index)" @click="goToSlide(index)">{{index+1}}
            </li>
          </ul>
        </div>
      </div>
      <div class="h_right">
        <img src="@/assets/home/images/logo.jpg" alt="">
      </div>
    </div>
    <Top />
    <div class="home_container">
      <div class="h_top">
        <div class="h_top_l">
          <img src="@/assets/home/images/events_tit.gif" alt="图片">
          <img src="@/assets/home/images/headline_fonts_s.gif" alt="图片">
          <router-link class="h_brand" to="">
            <img src="@/assets/home/images/201211031747554755.jpg" alt="">
          </router-link>
          <router-link class="h_more" to="/contact">
            <img src="@/assets/home/images/read_more_details.gif" alt="">
            <span>点击查阅详细内容</span>
          </router-link>
        </div>
        <div class="h_top_r">
          <img src="@/assets/home/images/today_is.gif" alt="图片">
          <div class="h_date">
            <img :src="getImageSrc(currentDate.year)" alt="">
            <img :src="getImageSrc(currentDate.month)" :alt="currentDate.month">
            <img :src="getImageSrc(currentDate.day)" :alt="currentDate.day">
          </div>
          <div class="sayHello"><strong>Sunday.</strong>You are <i></i> visitor.Welcome to <a href="/about/">oodow</a>
            !
          </div>
          <div class="IndexQuote"><span>Quote Today by oodow Team</span><a href="/reason/" target="_blank">"Off as a
              friend, Imitation of Nature..."</a>
          </div>
        </div>
      </div>
      <div class="h_bottom">
        <div class="h_bottom_l">
          <div class="h_bottom_t">
            <p class="linetitle">
              <img src="@/assets/home/images/title4.jpg" class="pt2">
              <router-link class="more2" to="/cases">more</router-link>
            </p>
          </div>
          <div class="h_customer">
            <ul class="customlist">
              <li v-for="(item,index) in customers.slice(0,9)" :key="index">
                <router-link :to="{path:'/casesdetail',query:{id:item.id,category_id:item.category_id}}" class="imgbox" style="opacity: 1;">
                  <img :src="item.picture" alt="机智鸟">
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <p class="hline"></p>
        <div class="h_bottom_c">
          <div class="h_bottom_t">
            <p class="linetitle">
              <img src="@/assets/home/images/title5.jpg" class="pt2">
              <router-link class="more2" to="/news">more</router-link>
            </p>
          </div>
          <div v-if="newNews.length>0" id="scrollDiv">
            <swiper :options="newsSwiper" class="indexnewslist">
              <swiper-slide class="newsItem" v-for="(item,index) in newNews" :key="index">
                <router-link :to="{path:'/newsdetail',query:{id:item.id,category_id:item.category_id}}">{{item.title}}</router-link>
                <span>{{item.created_at[1]}}-{{item.created_at[2]}}</span>
              </swiper-slide>
            </swiper>
          </div>
        </div>
        <p class="hline"></p>
        <div class="h_bottom_r">
          <div class="h_bottom_t">
            <p class="linetitle">
              <img src="@/assets/home/images/title6.jpg" class="pt2">
              <router-link class="more2" to="/contact">more</router-link>
            </p>
            </p>
            <ul class="contact">
              <!-- <p style=" padding-left:5px; padding-top: 15px; padding-bottom: 15px;">
                <img src="/storage/images/20220909/0a131055923b44882a1cb1d902af7c2a.png" width="207" height="31">
              </p> -->
              <p class="contacttxt clear"  style=" padding-left:5px; padding-top: 20px; padding-bottom: 15px;">
                <img src="/storage/images/20220619/c71986b43dcdc641a00dba9361efe67e.png">
              </p>
              <div class="contact_code">
                <div class="code_item">
                  <img :src="siteList.wechat_public" alt="">
                  <span>扫码关注</span>
                </div>
                <div class="code_item">
                  <img :src="siteList.kefu" alt="">
                  <span>立即联系</span>
                </div>
              </div>
            </ul>
          </div>
        </div>
      </div>
      <div class="index_link">
        友情链接：&nbsp;&nbsp;
        <a v-for="(item,index) in linkList" :href="item.link">{{item.title}}</a>
      </div>
      <p class="index_link1">
        <a href="https://beian.miit.gov.cn" target="_blank">ICP备案号：{{siteList.icp_number}}</a>
        <a href="https://beian.miit.gov.cn" target="_blank">公安备案号：{{siteList.ps_number}}</a>
      </p>
    </div>
  </div>
</template>
<script>
  import Top from '@/components/top'
  export default {
    components: {
      Top
    },
    props: ['siteList'],
    data() {
      return {
        customers: [],
        newsList: [],
        linkList: [],
        bannerList: [],
        day2: 1,
        day3: 6,
        currentIndex: 0,
        bannerSwiper: {
          pagination: {
            el: ".dot",
            clickable: true,
          },
          on: {
            slideChangeTransitionStart: this.updateActiveIndex,
          },
        },
        newsSwiper: {
          direction: 'vertical',
          speed: 500,
          loop: true,
          slidesPerView: 8,
          spaceBetween: 10,
          autoplay: {
            disableOnInteraction: false
          },
        }
      }
    },
    created() {
      this.getCustomer()
      this.getNews()
      this.getLink()
      this.getBanner()
    },
    computed: {
      newNews() {
        this.newsList.forEach((item) => {
          item.created_at = item.created_at.split(' ')
          item.created_at = item.created_at[0].split('-')
        })
        return this.newsList
      },
      currentDate() {
        const date = new Date();
        return {
          year: date.getFullYear(),
          month: date.getMonth() + 1, // 月份从0开始，所以需要加1
          day: date.getDate()
        };
      }
    },
    methods: {
      getImageSrc(month) {
        // 确保月份是两位数的字符串形式 month ;
        return require(`@/assets/home/images/${month}.gif`);
      },
      hoverSlide(index) {
        this.$refs.mySwiper.swiper.slideTo(index);
      },
      updateActiveIndex() {
        this.currentIndex = this.$refs.mySwiper.swiper.realIndex;
      },
      goToSlide(index) {
        this.$refs.mySwiper.swiper.slideTo(index);
      },
      async getCustomer() {
        let res = await this.$request.post('cases/getAll', {
          fil: 1
        })
        if (res.data.code === 0) {
          this.customers = res.data.data
        }
      },
      async getNews() {
        let res = await this.$request.post('news/getAll', {
          fil: 1
        })
        if (res.data.code === 0) {
          this.newsList = res.data.data.slice(0, 7)
        }
      },
      async getLink() {
        let res = await this.$request.post('link/getAll')
        if (res.data.code === 0) {
          this.linkList = res.data.data
        }
      },
      async getBanner() {
        let res = await this.$request.post('banner/getAll')
        if (res.data.code === 0) {
          this.bannerList = res.data.data
        }
      }
    },
  }
</script>
<style lang="">

</style>